<template>
  <v-app dark>
    <v-content class="">
      <v-container fluid fill-height>
        <v-layout column justify-center align-center>
          <v-spacer></v-spacer>

          <v-flex row xs12 sm8 md4 class="minimal-width">
            <v-col cols="12"> </v-col>
            <v-form
              @submit.prevent="onSignin(username, password)"
              class="form-size"
              ref="signinForm"
              lazy-validation
            >
              <v-card class="loginform">
                <div class="mb-5">
                  <v-alert
                    :value="errorMessage"
                    outlined
                    dismissible
                    type="warning"
                    class="min-width"
                  >
                    {{ errorMessage }}
                  </v-alert>
                </div>
                <v-card-text style="background:white;">
                  <div class="mb-4">
                    <h2 class="display-2">LotoJr</h2>
                  </div>
                  <v-text-field
                    label="Usuario"
                    type="text"
                    v-model="username"
                    :maxlength="30"
                    :rules="usernameRules"
                    required
                  >
                  </v-text-field>
                  <v-text-field
                    label="Senha"
                    :rules="passwordRules"
                    v-model="password"
                    :maxlength="30"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'"
                    required
                  >
                  </v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    :loading="signinLoading && !error"
                    type="submit"
                  >
                    Entrar
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>

            <div style="margin-top: 20px; padding: 20px 0 20px 0">
              <v-divider></v-divider>
            </div>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      showPassword: false,
      signinLoading: false,
      username: "",
      password: "",
      usernameRules: null,
      passwordRules: null,
    };
  },
  computed: {
    ...mapGetters({
      error: "error",
    }),
    errorMessage() {
      if (this.error) {
        return this.error;
      }
      return null;
    },
  },
  watch: {
    locale(v) {
      this.resetForm();
      this.createRules();
    },
    errorMessage(v) {
      console.log(v);
    },
  },
  created() {
    this.createRules();
  },
  methods: {
    createRules() {
      this.usernameRules = [(v) => !!v || "Usuário é obrigatório"];
      this.passwordRules = [(v) => !!v || "Senha é obrigatório"];
    },
    resetForm() {
      this.$refs.signinForm.reset();
    },
    validateForm() {
      if (this.$refs.signinForm.validate()) {
        return true;
      }
      return false;
    },
    onSignin(email, password) {
      if (this.validateForm()) {
        this.signinLoading = true;
        this.$store
          .dispatch("signUserIn", {
            email,
            password,
          })
          .then((result) => {
            this.$router.go("/").catch((e) => {});
          })
          .catch((err) => console.log(err))
          .finally(() => {
            this.signinLoading = false;
          });
      }
    },
    goToOnSignUp() {
      this.$router.push("/signup");
    },
  },
};
</script>

<style scoped>
.margin-zero {
  margin-left: 0px !important;
}

@media (min-width: 601px) {
  .form-size {
    min-width: 400px;
  }
}

@media (max-width: 600px) {
  .minimal-width {
    width: 100%;
  }
}

.my-link:hover {
  color: #aeb8f5;
}

.loginform {
  border: solid 1.5px grey;
}
</style>
